var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateGrayscale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2406 43.4285C10.6796 43.4285 3.93971 50.2242 4.61855 58.1717L8.55691 104.006C9.16571 111.102 15.5285 116.571 23.1789 116.571H136.82C144.465 116.571 150.828 111.102 151.442 104.006L155.381 58.1717C156.065 50.2297 149.32 43.4285 140.759 43.4285H19.2406Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2134 44.4457L102.453 33.8229C102.585 33.8 102.716 33.7886 102.848 33.7886C103.95 33.7886 104.888 34.5771 105.082 35.6629L108.596 55.5771C108.699 56.1771 108.556 56.8057 108.196 57.2971L103.076 64.3886C102.688 64.9314 102.499 65.6 102.545 66.2629L47.7562 75.9257L42.2076 44.4457H42.2134Z",
    fill: "#C2C2C2",
    stroke: "#999999",
    strokeWidth: 1.14286
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3277 118.943C59.7106 118.943 57.4763 117.069 57.0192 114.48L45.402 48.5943C44.8877 45.6629 46.8477 42.8572 49.7792 42.3429L79.6934 37.0686L106.871 56.7143L115.248 104.217C115.762 107.149 113.802 109.954 110.871 110.469L63.2706 118.857C62.9563 118.914 62.642 118.943 62.3277 118.943Z",
    fill: "#C2C2C2",
    stroke: "#999999",
    strokeWidth: 1.14286
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6648 58.9144C86.2534 58.9144 84.1962 57.1887 83.7734 54.8058L80.7848 37.8516L105.842 55.9658L89.5334 58.8401C89.2476 58.8916 88.9562 58.9144 88.6648 58.9144Z",
    fill: "#EBEBEB",
    stroke: "#999999",
    strokeWidth: 1.14286
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.642 123.429C51.4991 123.429 50.5277 122.612 50.3334 121.486L36.922 45.4458C36.8134 44.8287 36.9505 44.2058 37.3105 43.6915C37.6705 43.1772 38.2077 42.8344 38.8305 42.7258L96.202 32.6058C96.3391 32.583 96.4763 32.5715 96.6134 32.5715C97.7563 32.5715 98.7277 33.3887 98.9277 34.5144L112.333 110.554C112.556 111.829 111.705 113.052 110.425 113.28L53.0534 123.394C52.9163 123.417 52.7791 123.429 52.642 123.429Z",
    fill: "#D6D6D6",
    stroke: "#999999",
    strokeWidth: 1.14286
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.959 89.791L77.3552 94.1292C76.6373 94.2558 76.1579 94.9404 76.2845 95.6583L78.8128 109.997C78.9394 110.715 79.6241 111.194 80.342 111.068L104.945 106.73C105.663 106.603 106.143 105.918 106.016 105.2L103.488 90.8617C103.361 90.1437 102.676 89.6644 101.959 89.791Z",
    fill: "#ADADAD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0077 127.949C46.3905 127.949 44.1562 126.074 43.6991 123.486L32.0819 57.6002C31.5677 54.6687 33.5277 51.863 36.4591 51.3487L66.3734 46.0745L93.5505 65.7202L101.928 113.223C102.179 114.64 101.859 116.074 101.036 117.257C100.208 118.44 98.9734 119.223 97.5562 119.474L49.9562 127.863C49.6419 127.92 49.3277 127.943 49.0134 127.943L49.0077 127.949Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 1.14286
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M75.3505 67.9203C72.939 67.9203 70.8819 66.1946 70.459 63.8117L67.4705 46.8574L92.5276 64.9717L76.219 67.846C75.9333 67.8974 75.6419 67.9203 75.3505 67.9203Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3505 67.9203C72.939 67.9203 70.8819 66.1946 70.459 63.8117L67.4705 46.8574L92.5276 64.9717L76.219 67.846C75.9333 67.8974 75.6419 67.9203 75.3505 67.9203Z",
    stroke: "#999999",
    strokeWidth: 1.14286
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.834 74.5714C130.656 74.5714 139.428 65.7987 139.428 54.9771C139.428 44.1555 130.656 35.3828 119.834 35.3828C109.013 35.3828 100.24 44.1555 100.24 54.9771C100.24 65.7987 109.013 74.5714 119.834 74.5714Z",
    fill: "#7A7A7A"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.88 72.617C128.702 72.617 137.474 63.8444 137.474 53.0228C137.474 42.2011 128.702 33.4285 117.88 33.4285C107.058 33.4285 98.2856 42.2011 98.2856 53.0228C98.2856 63.8444 107.058 72.617 117.88 72.617Z",
    fill: "#7A7A7A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M117.88 58.8113C116.788 58.8113 115.903 57.9256 115.903 56.8342V53.5713C115.903 52.4799 116.788 51.5942 117.88 51.5942C119.491 51.5942 120.806 50.2856 120.806 48.6685C120.806 47.0513 119.497 45.7428 117.88 45.7428C116.263 45.7428 114.954 47.0513 114.954 48.6685C114.954 49.7599 114.068 50.6456 112.977 50.6456C111.886 50.6456 111 49.7599 111 48.6685C111 44.8799 114.086 41.7942 117.874 41.7942C121.663 41.7942 124.748 44.8799 124.748 48.6685C124.748 51.7142 122.748 54.3828 119.851 55.2513V56.8285C119.851 57.9199 118.966 58.8056 117.874 58.8056L117.88 58.8113Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M117.88 64.1142C116.789 64.1142 115.903 63.2285 115.903 62.1371C115.903 61.0456 116.789 60.1599 117.88 60.1599C118.971 60.1599 119.857 61.0456 119.857 62.1371C119.857 63.2285 118.971 64.1142 117.88 64.1142Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateGrayscale);
export default __webpack_public_path__ + "static/media/empty-state-grayscale.e9a887136d1c9c2fc4498d0476abfd9c.svg";
export { ForwardRef as ReactComponent };